import React, { useRef, useState } from "react";

type MenuButtonKey = "ArrowDown" | "ArrowUp";

const menuOpenKeys: MenuButtonKey[] = ["ArrowDown", "ArrowUp"];

export const useObjectMenu = () => {
    const menuAnchor = useRef<HTMLButtonElement>(null);
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const handleMenuButtonClick = () => {
        setIsMenuOpen(true);
    };

    const handleMenuButtonKeyDown = (
        event: React.KeyboardEvent<HTMLButtonElement>,
    ) => {
        if (!menuOpenKeys.includes(event.key as MenuButtonKey)) {
            return;
        }

        event.preventDefault();
        setIsMenuOpen(true);
    };

    return {
        menuAnchor,
        isMenuOpen,
        setIsMenuOpen,
        handleMenuButtonClick,
        handleMenuButtonKeyDown,
    };
};
